import SitemapMapper from './SitemapMapper';

export default SitemapMapper;
